import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "Connect with us and get started.": "Connect with us and get started.",
      "Fill Telephone number": "Fill Telephone number",
      "Enter a 6-digit code we have sent to" : "Enter a 6-digit code we have sent to",
      "Time remaining" : "Time remaining",
      "minute" : "minute",
      "Didn't get a text?" : "Didn't get a text?",
      "Send again" : "Send again",
      "If you haven't received the code? Request a new code within 3 minutes. Code will be expired After 3 minutes" : "If you haven't received the code? Request a new code within 3 minutes. Code will be expired After 3 minutes",
      "OTP is incorrect" : "OTP is incorrect",
      "Phone number invalid" : "Phone number invalid",
      "This phone number is incorrect?" : "This phone number is incorrect?",
      "Change" : "Change",
      "Change your phone number" : "Change your phone number",
      "Fill the new telephone number" : "Fill the new telephone number",
      "Room Cleaning" : "Room Cleaning",
      "AC. Cleaning" : "AC. Cleaning",
      "Starting at " : "Starting at ",
      "OTP has expired,Please try again" : "OTP has expired,Please try again",
      "Please try again later." : "Please try again later."



    } 
  },
  th: {
    translation: {
      "Connect with us and get started.": "เริ่มต้นใช้งานกับเรา",
      "Fill Telephone number": "กรุณากรอกเบอร์โทรศัพท์",
      "Enter a 6-digit code we have sent to": "ใส่รหัส 6 หลัก Living Tech ส่งไปที่หมายเลข",
      "Time remaining": "เหลือเวลาอีก",
      "minute": "นาที",
      "Didn't get a text?": "ไม่ได้รับข้อความ?",
      "Send again": "ส่งใหม่อีกครั้ง",
      "If you haven't received the code? Request a new code within 3 minutes. Code will be expired After 3 minutes" : "หากคุณยังไม่ได้รับรหัส? ขอรหัสใหม่ได้ภายใน 3 นาที และรหัสจะหมดอายุ หลังจาก 3 นาทีไปแล้ว",
      "OTP is incorrect" : "รหัส OTP ไม่ถูกต้อง",
      "Phone number invalid" : "หมายเลขโทรศัพท์ไม่ถูกต้อง",
      "This phone number is incorrect?" : "หมายเลขโทรศัพท์ไม่ถูกต้อง?",
      "Change" : "แก้ไข",
      "Change your phone number" : "เปลี่ยนเบอร์โทร์ศัพท์",
      "Fill the new telephone number" : "กรูณากรอกหมายเลขโทรศัพท์ใหม่ที่ต้องการ",
      "Room Cleaning" : "ทำความสะอาด",
      "AC. Cleaning" : "ล้างแอร์",
      "Starting at " : "เริ่มต้นที่ ",
      "OTP has expired,Please try again" : "OTP หมดอายุ โปรดลองอีกครั้ง",
      "Please try again later." : "กรุณาลองใหม่อีกครั้ง"
    }
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    whitelist: ['th', 'en'],
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;